import React, { useEffect, useState } from 'react'

// Translation
import { useTranslation } from 'react-multi-lang'

// Redux
import { useDispatch, useSelector } from 'react-redux'
import { editProfileSlice, editProfileState } from './EditProfileSlice'
// Components
import Modal from '../../components/Modal/Modal'
import { InputField } from '../../components/FormElements/FormElements'
import { SuccessMark, WhiteboxLoader } from '../../components/Loader/Loader'

import { useAPI } from '../../services/hoc/useAPI'

export default () => {
    
    // Translation
    const t = useTranslation()

    // Redux
    const dispatch = useDispatch()
    const state = useSelector( ( state: { edit_profile: editProfileState } ) => state.edit_profile )

const ENDPOINTS = useAPI()

    // Hooks
    const [ showErrors, setShowErrors ] = useState<boolean>(false)

    // Add service
    const add = ( e: React.FormEvent<HTMLFormElement> ) => {
        
        e.preventDefault()

        if( !state.fields.name || !state.fields.email || !state.fields.mobile ) {
            setShowErrors(true)
            return
        }

        dispatch( editProfileSlice.actions.setIsLoading(true) )

        ENDPOINTS.users().update_my_info(state.fields)
        .then((response: any) => {
            dispatch( editProfileSlice.actions.setIsSuccess(true) )
            setTimeout(() => {
                toggle()
                dispatch( editProfileSlice.actions.init() )
            }, 1000);
        })

    }

    const fetchUserInfo = () => {
        ENDPOINTS.users().fetch_my_info(null)
        .then((response: any) => {
            dispatch( editProfileSlice.actions.setIsLoaded(true) )
            dispatch( editProfileSlice.actions.set({
                name: response.data.data.name,
                email: response.data.data.email,
                mobile: response.data.data.mobile,
                password: ""
            }) )
        })
    }

    const toggle = () => {
        dispatch( editProfileSlice.actions.setIsOpen(false) )
    }

    useEffect(() => {
        if(!state.isLoaded && state.isOpen)
            fetchUserInfo()
    }, [state.isOpen])

    return(
        <Modal open={state.isOpen} toggle={toggle}>

            { state.isLoading ? <WhiteboxLoader /> : ""}

            { state.isSuccess ? <SuccessMark /> : ""}
            
            <h2 className="text-center" style={{ margin: "0 0 20px" }}>{t("edit_profile")}</h2>

            <form onSubmit={add} style={{ width: 400, maxWidth: "100%" }}>

                <InputField
                    label={t("name") + " *"}
                    onChange={(e: React.ChangeEvent<HTMLInputElement>) => dispatch( editProfileSlice.actions.set({ name: e.target.value }) )}
                    value={state.fields.name}
                    error={(showErrors && !state.fields.name) ? t("required_error") : ""} />

                <InputField
                    type="email"
                    label={t("email") + " *"}
                    onChange={(e: React.ChangeEvent<HTMLInputElement>) => dispatch( editProfileSlice.actions.set({ email: e.target.value }) )}
                    value={state.fields.email}
                    error={(showErrors && !state.fields.email) ? t("required_error") : ""} />
                
                <InputField
                    label={t("phone") + " *"}
                    onChange={(e: React.ChangeEvent<HTMLInputElement>) => dispatch( editProfileSlice.actions.set({ mobile: e.target.value }) )}
                    value={state.fields.mobile}
                    error={(showErrors && !state.fields.mobile) ? t("required_error") : ""} />
                
                <InputField
                    type="password"
                    label={t("password")}
                    onChange={(e: React.ChangeEvent<HTMLInputElement>) => dispatch( editProfileSlice.actions.set({ password: e.target.value }) )}
                    value={state.fields.password} />

                <button className="button round bg-gold color-white margin-top-30" style={{ padding: "0 80px", marginBottom: 5 }}>{t("save")}</button>

            </form>

        </Modal>
    )

}